import $ from "jquery";
import { RML_REST_BUTTON_PREPARE, RML_REST_BUTTON_SUCCESS } from "../events/restButton.js";
import { __ } from "../utils/i18n.js";
import { request } from "../utils/request.js";
/**
 * Do the options screen with a nav bar (WordPress standard). This
 * nav bar is not ReactJS.
 */ function optionsScreen() {
    // Append to known option
    const container = $('<div class="rml-options"><nav><ul></ul></nav></div>').insertBefore($('[for="rml_load_frontend"]').parents("table").prev());
    const nav = container.find("nav ul");
    let navLiCnt = 0;
    $("<h3>Real Media Library</h3>").insertBefore(container);
    // Search the option panels
    $("table.form-table").each(function() {
        const oHeadline = $(this).prev();
        let sHeadline = oHeadline.html();
        if (sHeadline && sHeadline.indexOf("RealMediaLibrary") === 0) {
            const [, headlineSuffix] = sHeadline.split(":", 2);
            sHeadline = headlineSuffix;
            // Append headline to options panel
            const li = $(`<li class="nav-tab ${navLiCnt === 0 ? "nav-tab-active" : ""}">${sHeadline}</li>`).appendTo(nav);
            const section = $(this).appendTo(container);
            !navLiCnt && section.show();
            li.click(function() {
                container.children("table").hide();
                nav.find(".nav-tab-active").removeClass("nav-tab-active");
                $(this).addClass("nav-tab-active");
                section.show();
            });
            // Hash navigation
            let hashObj;
            const hash = window.location.hash.split("rml-", 2);
            if (hash.length > 1 && (hashObj = section.find(`#${hash[1]}`)).length) {
                li.click();
                // Scroll to element
                setTimeout(()=>$("html, body").animate({
                        scrollTop: hashObj.offset().top - 170
                    }, 500), 300);
            }
            oHeadline.remove();
            navLiCnt++;
        }
    });
}
function bindOptionsRestButtons() {
    $(document).on("click", ".rml-rest-button", function(e) {
        const { url, method, urlnamespace, ...data } = $(this).data();
        const btn = $(this);
        if ($(this).attr("disabled") !== "disabled" && window.confirm(__("Are you sure?"))) {
            btn.html('<div class="spinner is-active" style="float: initial;margin: 0;"></div>');
            btn.attr("disabled", "disabled");
            if (url === "import") {
                data.import = encodeURIComponent($("#rml_import_data textarea").get(0).value);
            }
            document.dispatchEvent(new CustomEvent(RML_REST_BUTTON_PREPARE, {
                detail: {
                    url,
                    data,
                    button: btn.get(0)
                },
                bubbles: true
            }));
            request({
                location: {
                    path: url,
                    method,
                    namespace: urlnamespace
                },
                request: data
            }).then((response)=>{
                btn.html(`<i class="fa fa-check"></i> ${__("Success")}`);
                if (url === "export") {
                    $("#rml_export_data textarea").get(0).value = response;
                }
                document.dispatchEvent(new CustomEvent(RML_REST_BUTTON_SUCCESS, {
                    detail: {
                        url,
                        response,
                        method,
                        data,
                        button: btn.get(0)
                    },
                    bubbles: true
                }));
            }, ()=>{
                btn.html(`<i class="fa fa-warning"></i> ${__("Failed")}`).removeAttr("disabled");
            });
        }
        e.preventDefault();
        return false;
    });
}
export { bindOptionsRestButtons, optionsScreen };
